<script setup>
import { computed } from "vue";

const props = defineProps({
  // state can be 'none', 'checking', 'ok', 'error', 'corrupted', 'slow',
  state: String,
});

const stateColor = computed(() => {
  if (props.state === "ok") {
    return "green";
  } else if (props.state === "checking") {
    return "blue";
  } else if (props.state === "error") {
    return "red";
  } else if (props.state === "corrupted") {
    return "orange";
  } else if (props.state === "slow") {
    return "yellow";
  }
  else {
    return "grey";
  }
});
</script>

<template>
  <v-icon :color="stateColor" v-if="state === 'none'"
    >mdi-emoticon-neutral</v-icon
  >
  <v-icon :color="stateColor" v-else-if="state === 'ok'">
    mdi-emoticon-happy
  </v-icon>

  <v-icon :color="stateColor" v-else-if="state === 'corrupted'">
    mdi-heart-broken
  </v-icon>
  <v-icon :color="stateColor" v-else-if="state === 'slow'">
    mdi-speedometer-slow
  </v-icon>

  <v-progress-circular indeterminate size="20" :color="stateColor" v-else-if="state === 'checking'">
  </v-progress-circular>
  <v-icon :color="stateColor" v-else-if="state === 'error'">
    mdi-emoticon-sad
  </v-icon>
</template>
